import React from 'react';
import { Box, Flex, Inline, Stack, xcss } from '@atlaskit/primitives';
import { ff } from '@atlassian/jira-feature-flagging';

export const TransitionHomeContentBox = ({
	children,
	footer,
	illustration,
}: {
	children: React.ReactNode;
	footer?: React.ReactNode;
	illustration?: React.ReactNode;
}) => {
	const isOptimalTooling = ff('platform.show-optimal-tooling_brgom');

	if (isOptimalTooling) {
		return (
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
			<div className="transition-home-content-box">
				<Stack xcss={wrapperInlineStyles}>
					<Inline grow="fill" alignInline="center" alignBlock="center">
						<Box xcss={leftBoxStyles} padding="space.300">
							{children}
						</Box>
						<Box padding="space.300" xcss={illustrationWrapperBoxStyles}>
							<Flex alignItems="center" justifyContent="center">
								{illustration}
							</Flex>
						</Box>
					</Inline>
					{footer && (
						<Box padding="space.300" paddingBlockStart="space.0">
							{footer}
						</Box>
					)}
				</Stack>
			</div>
		);
	}

	return (
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
		<div className="transition-home-content-box">
			<Inline grow="fill" spread="space-between" alignBlock="center" xcss={wrapperInlineStyles}>
				<Box xcss={leftBoxStyles} padding="space.300">
					{children}
				</Box>
				<Box padding="space.300" xcss={illustrationWrapperBoxStyles}>
					<Flex alignItems="center" justifyContent="center">
						{illustration}
					</Flex>
				</Box>
			</Inline>
		</div>
	);
};

const leftBoxStyles = xcss({
	width: '100%',
});

const illustrationWrapperBoxStyles = xcss({
	width: '320px',
	flexShrink: 0,
});

const wrapperInlineStyles = xcss({
	boxShadow: 'elevation.shadow.raised',
	borderRadius: 'border.radius.200',
});
